<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="90px">
    <div class="df-protit">
      {{ title }}
      <span @click="close">返回列表</span>
    </div>
    <el-row :gutter="24">
      <el-col :span="8">
        <el-table
          :data="dataLeft"
          :border="true"
          style="width: 100%"
          :cell-style="{
            'text-align': 'left',
            'border-color': '#dbdbdb',
            position: 'relative',
            'background-color': '#f3f1f2',
            'border-right': '1px solid #e7e6e4',
          }"
          :header-cell-style="{
            'background-color': '#b6b6b6',
            color: '#000',
            fontSize: '14px',
            fontWeight: '300',
            color: '#fff',
          }"
        >
          <el-table-column prop="date" label="包含产品列表">
            <template slot-scope="scope">
              <div
                style="padding:5px;word-wrap:break-word;word-break:normal;white-space:normal"
              >
                <div
                  class="goods"
                  style="float:left;max-width:85;width:30%;height:100%; padding: 10px 2px 20px 2px;"
                >
                  <img
                    v-if="scope.row.pcImg"
                    :src="scope.row.pcImg"
                    width="70px"
                    height="70px"
                  />
                  <img
                    v-else
                    src="../../../images/image.png"
                    width="70px"
                    height="70px"
                  />
                </div>
                <div style="float:right;height:100%;width:70%;">
                  <div style="min-height: 45px;">
                    <b>{{ scope.row.goodsName }}</b>
                  </div>
                  <div style="padding: 5px 0px;">
                    SKU：{{ scope.row.goodsSku }}
                  </div>
                </div>
                <br />
                <div style="padding: 5px 0px;height: 35px;width:100%;">
                  数量：<el-input-number
                    v-model="scope.row.amount"
                    size="mini"
                    :min="1"
                    :max="1000"
                    step-strictly
                    style="width:100px;"
                    @change="updateGoods(scope.$index, scope.row)"
                  ></el-input-number>
                  <div style="float:right">
                    <el-link
                      type="primary"
                      @click="deleteGoods(scope.$index, scope.row)"
                      >删除</el-link
                    >
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding:15px 5px 15px 50px;">
          组合价格：{{ to_f(sumPrice || 0.0) }}
        </div>
        <div style="padding:15px 0;">
          <el-button style="width:100%;border-color:#97c5e9" @click="close"
            >确认/保存</el-button
          >
        </div>
      </el-col>
      <el-col :span="15">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="商品名称：" style="width: 100%;">
              <el-input
                v-model="searchText"
                placeholder="请输入商品名称"
                clearable
                size="small"
                style="width: 100%;"
            /></el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="SKU：" class="mm9" style="width:  100%">
              <el-input
                v-model="searchCode"
                placeholder="请输入商品SKU"
                clearable
                size="small"
                style="width: 100%;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="el-form-item__label">
              <el-button
                type="cyan"
                icon="el-icon-search"
                size="mini"
                @click="handleQuery"
              >
                搜 索
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-table
          :data="aryList"
          :show-header="false"
          :border="true"
          style="width: 100%"
          :cell-style="{
            'text-align': 'left',
            'border-color': '#dbdbdb',
            position: 'relative',
            'background-color': '#f3f1f2',
            'border-right': '1px solid #e7e6e4',
          }"
        >
          <el-table-column label="商品信息"
            ><template slot-scope="scope">
              <div
                style="padding:5px;word-wrap:break-word;word-break:normal;white-space:normal"
              >
                <div
                  class="goods"
                  style="float:left;max-width:95;width:30%;height:100%; padding: 10px 2px 20px 2px;"
                >
                  <img
                    v-if="scope.row.pcImg"
                    :src="scope.row.pcImg"
                    width="70px"
                    height="70px"
                  />
                  <img
                    v-else
                    src="../../../images/image.png"
                    width="70px"
                    height="70px"
                  />
                </div>
                <div style="float:right;height:100%;width:70%;">
                  <div style="min-height: 50px;">
                    <b>{{ scope.row.goodsName }}</b>
                  </div>
                  <div style="min-height: 35px;">
                    SKU：{{ scope.row.sku }}
                    <br />
                    价格：{{ scope.row.marketPrice }}
                  </div>
                </div>
              </div>
            </template></el-table-column
          >
          <el-table-column width="150" label="操作"
            ><template slot-scope="scope">
              <div style="margin-top:5px;">
                <el-input-number
                  v-model="scope.row.amount"
                  :min="1"
                  :max="1000"
                  size="mini"
                  step-strictly
                  style="width:100px;"
                ></el-input-number>
                <br /><br />
                <el-button
                  size="mini"
                  style="border-color:#97c5e9"
                  @click="addGoods(scope.$index, scope.row)"
                  >加入组合</el-button
                >
              </div>
            </template></el-table-column
          >
        </el-table>
        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button size="mini" style="display:inline-block;">GO</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import {
  goodsListRequest,
  getSetmealGoodsListRequest,
  addSetmealGoodsRequest,
  editSetmealGoodsRequest,
  delSetmealGoodsRequest,
} from "../../../public/js/service";

export default {
  name: "TableEdit",
  props: ["row"],
  components: {},
  data() {
    return {
      dataLeft: [],
      dataGoods: [],
      totalPages: 1, // 1.1.总页码,
      pageNum: 1, // 1.2.当前页码
      total: 1, // 1.3.总条数
      pageSize: 10, // 1.4.每页条数
      aryList: [], // 1.5.商品列表数据
      token: "",
      searchText: null,
      searchCode: null,
      form: {
        title: "",
      },
      rules: {},
      title: "",
      sumPrice: 0.0,
    };
  },
  created() {},
  beforeunloadFn(e) {
    console.log(e);
  },
  watch: {
    row: function(val) {
      console.log(val);
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getList(); // 4.1.获取套餐列表信息
      }
    },
  },
  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.showEdit(this.row);
    }
  },
  methods: {
    showEdit(row) {
      if (!row) {
        this.title = "组合名称：" + (row.setmealName || "");
      } else {
        this.title = "组合名称：" + (row.setmealName || "");
        this.form = Object.assign({}, row);
      }
      if (row.setmealGoodsList) {
        let price = 0.0;
        this.dataLeft = row.setmealGoodsList;
        for (let j = 0; j < this.dataLeft.length; j++) {
          let item = this.dataLeft[j];
          let qq = parseInt(item["amount"] || "1");
          let pp = parseFloat(item["shopPrice"] || "99999.00");
          price += qq * pp;
        }
        this.sumPrice = price;
      }
      this.handleQuery();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },

    getList() {
      // 3.7.获取商品列表信息
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        classifyId: this.classifyId,
        priceRange: this.priceRange,
        goodsName: this.searchText,
        goodsCode: this.searchCode,
      };

      goodsListRequest(data).then((res) => {
        if (res) {
          this.total = res.totals || 1;
          this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
          this.aryList = res.data.map((item) => {
            item.amount = 1;
            return item;
          });

          this.goodsName = "";
        }
      });
    },
    handleQuery() {
      if (localStorage.token) {
        this.token = localStorage.token;
        if (localStorage.searchText) {
          this.searchText = localStorage.searchText;
        }
        this.getList(); // 4.1.获取商品列表信息
      }
    },
    close() {
      this.$emit("fetch-data");
    },
    getSetmealGoodsList() {
      let data = {
        setmealId: this.form.setmealId,
      };
      getSetmealGoodsListRequest(data).then((res) => {
        if (res) {
          let price = 0.0;
          this.dataLeft = res.data.map((item) => {
            let qq = parseInt(item["amount"] || "1");
            let pp = parseFloat(item["shopPrice"] || "99999.00");
            price += qq * pp;
            return item;
          });
          this.sumPrice = price;
        }
      });
    },

    deleteGoods(index, row) {
      let ids = [];
      ids.push(row.setmealGoodsId);
      let data = { ids: ids, index: index };
      delSetmealGoodsRequest(data).then((res) => {
        if (res) {
          if (res.code != 500) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getSetmealGoodsList();
          } else {
            this.$message({
              type: "error",
              message: "操作失败!",
            });
          }
        }
      });
    },
    addGoods(index, row) {
      console.log(row);
      let data = {};
      data.index = index;
      data.setmealId = this.form.setmealId;
      data.goodsId = row.goodsId;
      for (let j = 0; j < this.dataLeft.length; j++) {
        let rr = this.dataLeft[j];
        if (rr.goodsId == row.goodsId) {
          data.amount = (row.amount || 1) + (rr.amount || 1);
          data.setmealGoodsId = rr.setmealGoodsId;
          break;
        }
      }
      if (data.setmealGoodsId) {
        editSetmealGoodsRequest(data).then((res) => {
          if (res) {
            if (res.code != 500) {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getSetmealGoodsList();
            } else {
              this.$message({
                type: "error",
                message: "操作失败!",
              });
            }
          }
        });
      } else {
        data.amount = row.amount || 1;
        addSetmealGoodsRequest(data).then((res) => {
          if (res) {
            if (res.code != 500) {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getSetmealGoodsList();
            } else {
              this.$message({
                type: "error",
                message: "操作失败!",
              });
            }
          }
        });
      }
    },
    updateGoods(index, row) {
      console.log(row);
      let data = {};
      data.index = index;
      data.setmealId = this.form.setmealId;
      data.setmealGoodsId = row.setmealGoodsId;
      data.amount = row.amount || 1;
      editSetmealGoodsRequest(data).then((res) => {
        if (res) {
          if (res.code != 500) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getSetmealGoodsList();
          } else {
            this.$message({
              type: "error",
              message: "操作失败!",
            });
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.searchText {
  width: calc(100%-110px);
}
.mm9 {
  > .el-form-item__content {
    margin-left: 60px;
  }
  > .el-form-item__label {
    width: 60;
  }
}
</style>
